import { gql } from '@apollo/client';

/**
 * AB 映射可选维度：站点档案的 `联系人 × 关联客户(渠道)` 组合，附「已映射到哪」标注（2.1 §10.11）。
 *
 * 维度来自**站点档案**（`cw.contact_person_json × related_channel_ids`）——运营在站点信息里
 * 维护的联系人与关联客户，就是他心智模型里"这个地址会有谁下单"。AB 映射改的是**未来订单**的路由，
 * 所以不按历史订单筛：那样新地址、低频地址就永远无法预先映射，而"客户说以后都来 B 取"
 * 正是最需要映射的场景。无关联站点的条目（系统进单 / BD 录入）退回条目快照。
 *
 * 后端判整站作废用的是同一份列表 ⇒ 前端 `fullySelected` 与后端分母不会漂移。
 *
 * network-only：站点联系人/关联客户随时被运营改，缓存会让维度过期。
 */
export const GET_AB_DIMENSION_CANDIDATES = gql`
  query GetAbDimensionCandidates($reviewPoolId: Long!) {
    getAbDimensionCandidates(reviewPoolId: $reviewPoolId) {
      contactName
      contactPhone
      channelId
      mappedCooperationWarehouseId
    }
  }
`;

export interface AbDimensionCandidate {
  contactName?: string | null;
  contactPhone?: string | null;
  /** 后端 Long → GraphQL 序列化为字符串 */
  channelId?: string | number | null;
  /**
   * 该维度当前已映射到的 B 站点 id；null = 未映射。
   *
   * 界面据此：① 标注「已映射到 #id」② **默认不勾选**（重复提交会插入重复 active 行 ——
   * `deactivateOthersByDimension` 对"同维度同 B"不失效）③ 计入 `fullySelected`，
   * 否则「分批映射、最后一次补齐时触发退役」永远达不成。
   */
  mappedCooperationWarehouseId?: string | number | null;
}

export interface GetAbDimensionCandidatesResponse {
  getAbDimensionCandidates?: AbDimensionCandidate[] | null;
}
